export const createSession = (token, id, rememberMe, refreshToken) => {
  sessionStorage.setItem("token", token);
  sessionStorage.setItem("refreshToken", refreshToken);
  sessionStorage.setItem("id", id);
  if (rememberMe) {
    localStorage.setItem("token", token);
    localStorage.setItem("id", id);
  }
};

export const updateSessionToken = (token, refreshToken) => {
  sessionStorage.setItem("token", token);
  sessionStorage.setItem("refreshToken", refreshToken);
  if (localStorage.getItem("refreshToken")) {
    localStorage.setItem("refreshToken", refreshToken);
  }
}

export const clearSession = () => {
  sessionStorage.clear();
  localStorage.clear();
};

export const getSessionIdToken = () => {
  const sessionId = sessionStorage.getItem("id");
  const sessionToken = sessionStorage.getItem("token");
  const sessionRefreshToken = sessionStorage.getItem("refreshToken");
  const localId = localStorage.getItem("id");
  const localToken = localStorage.getItem("token");
  const localRefreshToken = localStorage.getItem("refreshToken");
  const id = sessionId ?? localId ?? "";
  const token = sessionToken ?? localToken ?? "";
  const refreshToken = sessionRefreshToken ?? localRefreshToken ?? "";
  return { id, token, refreshToken };
};
